// components/Layout/Topbar/SubscriptionBadge.jsx
import React from "react";

const SubscriptionBadge = ({ subscriptionDetails }) => {
  const { subscription } = subscriptionDetails;
  const daysLeft = subscription?.days_left;

  const getBadgeStyle = () => {
    if (daysLeft > 20) return "bg-green-100 text-green-800 border-green-200";
    if (daysLeft <= 20 && daysLeft > 5) return "bg-yellow-100 text-yellow-800 border-yellow-200";
    if (daysLeft <= 5) return "bg-red-100 text-red-800 border-red-200";
    return "bg-gray-100 text-gray-800 border-gray-200";
  };

  return (
    <div className={`hidden md:flex flex-col items-end px-3 py-2 rounded-lg border ${getBadgeStyle()}`}>
      <div className="text-sm font-semibold">
        {subscription?.package}
      </div>
      <span className="text-xs">
        {daysLeft} days remaining
      </span>
    </div>
  );
};

export default SubscriptionBadge;